import { isScheduledObjectType } from './scheduledEntity';

const TIMELINE_KIND_POST = 'POST';
const TIMELINE_KIND_ENTITY = 'ENTITY';

export function getTimelineProfileStats(items) {
    if (!Array.isArray(items)) {
        return {
            postsCount: null,
            eventsCount: null,
        };
    }

    return items.reduce(
        (totals, item) => {
            if (!item || typeof item !== 'object') {
                return totals;
            }
            if (item.timelineItemKind === TIMELINE_KIND_POST) {
                totals.postsCount += 1;
                return totals;
            }
            if (
                item.timelineItemKind === TIMELINE_KIND_ENTITY
                && isScheduledObjectType(item.objectType)
            ) {
                totals.eventsCount += 1;
            }
            return totals;
        },
        {
            postsCount: 0,
            eventsCount: 0,
        }
    );
}
